// src/components/Loading.js
import React from 'react';
import './Loading.css';

function Loading() {
  return (
    <div className="loading">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
}

export default Loading;
